export default [
  {
    path: 'dashboard/:id?',
    name: 'dashboard',
    component: () => import('@/views/dashboard/Dashboard.vue'),
    meta: { registerNavFromMenu: true }
  }
]
